export default __webpack_public_path__ + "static/real-time-edit-dark-da80598b236fb93fb2483a9b98048c16.png";